const DEFAULT_TTL = 120 * 1000;

// cache TTLs in milliseconds for TtlCacheStore
// Some integrations such as FastBill(on lower plans) have tight hourly API rate limits that a
// short TTL would eat into on every navigation-triggered refetch, thus a longer TTL is set.
export const INTEGRATIONS_CACHE_TTL = 30 * 60 * 1000;
export const LAYER_CACHE_TTL = DEFAULT_TTL;
export const CURRENT_USER_CACHE_TTL = DEFAULT_TTL;
export const ACCOUNT_CACHE_TTL = DEFAULT_TTL;
export const TILE_CACHE_TTL = DEFAULT_TTL;
